import { render, staticRenderFns } from "./ShareOrderShareRow.vue?vue&type=template&id=2295c1ea&scoped=true"
import script from "./ShareOrderShareRow.vue?vue&type=script&lang=js"
export * from "./ShareOrderShareRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2295c1ea",
  null
  
)

export default component.exports